var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getMenuType,attrs:{"id":"app-container"}},[_c('topnav'),_c('sidebar'),_c('main',[_c('div',{staticClass:"container-fluid custom-container-xxl"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }